import throttle from "lodash.throttle";
import refs from "./refs";

const $ = window.jQuery || window.$;

const { bodyEl, swiperToInit } = refs;

const throttledHandleResize = throttle(handleResize, 200);

let currentBackdrop = null;

export const showBackdrop = (backdrop, hideOnResize = false) => {
    if (!backdrop) {
        return;
    }
    disableBodyScroll();

    backdrop.removeClass("is-hidden");
    backdrop.on("click", handleBackdropClick);
    $(window).on("keydown", handleKeyDown);
    currentBackdrop = backdrop;

    if (hideOnResize) {
        $(window).on("resize", throttledHandleResize);
    }
};

export const hideBackdrop = (backdrop) => {
    if (!backdrop) {
        return;
    }

    enableBodyScroll();

    backdrop.addClass("is-hidden");
    backdrop.removeClass("click", handleBackdropClick);
    $(window).off("keydown", handleKeyDown);
    $(window).off("resize", throttledHandleResize);

    currentBackdrop = null;
};

function handleBackdropClick(e) {
    if (e.target === e.currentTarget) {
        hideBackdrop(currentBackdrop);
    }
}

function handleKeyDown(e) {
    if (e.key === "Escape") {
        hideBackdrop(currentBackdrop);
    }
}

function handleResize() {
    const { innerWidth } = window;

    if (innerWidth >= 768) {
        hideBackdrop(currentBackdrop);
    }
}

let savedScrollY = 0;
let scrollLockCount = 0;

export function enableBodyScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";
        document.body.style.overflowY = "";
        window.scrollTo(0, savedScrollY);
    }
}

export function disableBodyScroll() {
    if (scrollLockCount === 0) {
        savedScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
        document.body.style.position = "fixed";
        document.body.style.top = `-${savedScrollY}px`;
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";
        document.body.style.overflowY = "scroll";
    }
    scrollLockCount += 1;
}

const replaceInputWithButton = () => {
    const submitInput = $('.wpcf7-form [type="submit"]');
    const value = submitInput.val();

    submitInput.prop("outerHTML", function () {
        return this.outerHTML.replace(/input/gi, "button");
    });

    const newButton = $('.wpcf7-form [type="submit"]');
    newButton.text(value);
    newButton.attr("data-text", value);
};

const initSwiperClasses = () => {
    swiperToInit.each(function () {
        const currentElement = $(this);

        const replaceWithDiv = (selector, className) => {
            currentElement.find(selector).replaceWith(function () {
                return $('<div>', {
                    class: className,
                    html: $(this).html()
                });
            });
        };

        currentElement.find('div.gallery').addClass('swiper-wrapper');
        replaceWithDiv('dl', 'swiper-slide');
        currentElement.find('style, br').remove();
    });
}

initSwiperClasses();

export function renderEllipsisBullet(index, className) {
    const swiper = this;
    const total = swiper.slides.length;
    const current = swiper.realIndex;

    const numberOfBullets = 2;

    const isWithinRange = index >= current - numberOfBullets && index <= current + numberOfBullets;

    let isActive = (index === current) ? 'swiper-pagination-bullet-active fw-medium d-inline-flex align-items-center justify-content-center' : '';

    if (index === 0 || index === total - 1 || isWithinRange) {
        return `<span class="${className} fw-medium d-inline-flex align-items-center justify-content-center ${isActive}" role="button" tabindex="0" aria-label="Go to slide ${index + 1}">${index + 1}</span>`;
    }

    if (index === numberOfBullets && current - numberOfBullets > numberOfBullets - 1) {
        return '<span class="swiper-pagination-bullet-ellipsis fw-medium d-inline-flex align-items-center justify-content-center">...</span>';
    }

    if (index === total - numberOfBullets - 1 && current + numberOfBullets < total - numberOfBullets - 1) {
        return '<span class="swiper-pagination-bullet-ellipsis fw-medium d-inline-flex align-items-center justify-content-center">...</span>';
    }

    return '';
}

$('#single-case .hero-content__button').on("click", function () {
    const textToCopy = $('#single-case .hero-content__link a').attr('href');

    navigator.clipboard.writeText(textToCopy)
});

document.querySelectorAll('.share-list__link--copy').forEach((button) => {
    button.addEventListener('click', () => {
        const url = button.dataset.copyUrl;
        const toast = document.querySelector('.share-toast');

        if (!url || !navigator.clipboard) {
            return;
        }

        navigator.clipboard.writeText(url).then(() => {
            if (!toast) {
                return;
            }

            toast.classList.add('is-visible');

            window.setTimeout(() => {
                toast.classList.remove('is-visible');
            }, 2200);
        });
    });
});

$('.cf7-acceptance').prop('checked', true);

$('a[href="[privacy_policy_url]"]').attr('href', custom_vars.privacy_policy_url);

const findClosestH2 = (element) => {
    const closestModal = element.closest('div.modal');

    if (closestModal[0]) {
        return closestModal.find('h2');
    }

    const closestCtaWrapper = element.closest('div.cta-wrapper');

    return closestCtaWrapper.find('h2');
};

const cf7TitleInputs = $('.cf7-form-title');

cf7TitleInputs.each(function () {
    const closestH2 = findClosestH2($(this));
    $(this).val(closestH2.text());
});

$(document).ready(function () {
    if (bodyEl && bodyEl.length) {
        bodyEl.css("visibility", "visible");
    } else if (document.body) {
        document.body.style.visibility = "visible";
    }

    try {
        if (typeof window.WOW === "function") {
            new window.WOW().init();
        }
    } catch (e) {
        // Ignore WOW errors if not loaded
    }

    replaceInputWithButton();
});
